import * as React from "react";

class AudioImgDefault extends React.Component {
    render() {
        return (
            <div className="metilda-audio-analysis-image-default">
                <p>Choose an audio file to begin</p>
            </div>
        );
    }
}

export default AudioImgDefault;
